import { Vertex3Data, Vertex3DataIn } from './types';

export const vertex3Data = (dataIn: Vertex3DataIn = {}): Vertex3Data => {
	const position = {
		x: 0,
		y: 0,
		z: 0,
		readOnly: false,
		...dataIn
	};

	return position;
};
